import { createAction } from 'redux-actions';

export const photoManagerDialogPhotosUpload = createAction('PHOTO_MANAGER_DIALOG_PHOTOS_UPLOAD');
export const photoManagerDialogPhotosFetch = createAction('PHOTO_MANAGER_DIALOG_PHOTOS_FETCH');
export const photoManagerDialogPhotosSet = createAction('PHOTO_MANAGER_DIALOG_PHOTOS_SET');
export const photoManagerDialogPhotoDelete = createAction('PHOTO_MANAGER_DIALOG_PHOTO_DELETE');
export const photoManagerDialogTabsActiveKeySet = createAction('PHOTO_MANAGER_DIALOG_TABS_ACTIVE_KEY_SET');
export const photoManagerDialogRefresh = createAction('PHOTO_MANAGER_DIALOG_REFRESH');
